import React from 'react';
import config from '../../../../config';
import Header from '../../../components/Header/Header';
import Toolbar from '../../../components/Toolbar/Toolbar';
import Table from '../../../components/Table/Table';
import NavBar from '../../../components/NavBar/NavBar';
import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter';
import * as Yup from 'yup';
import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter';
import { Switch } from '@mui/material';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import { useTranslation } from 'react-i18next';

const PaymentReceiver = () => {
  const urls = {
    list: config.PAYMENT_RECEIVER,
    create: config.PAYMENT_RECEIVER,
    update: config.PAYMENT_RECEIVER_WITH_ID,
    delete: config.PAYMENT_RECEIVER_WITH_ID
  };
  const resource = 'PAYMENT';
  const { t } = useTranslation();

  const columns = [
    {
      header: t('id'),
      name: 'paymentReceiverId',
      type: 'number',
      filterEditor: NumberFilter
    },
    {
      header: t('name'),
      name: 'paymentReceiverName',
      type: 'string',
      validationSchema: Yup.string().max(255).required('Name is required'),
      required: true,
      isEditable: true,
      defaultFlex: 1
    },
    {
      header: t('address'),
      type: 'string',
      validationSchema: Yup.string().max(255).required('Address is required'),
      required: true,
      isEditable: true,
      name: 'address'
    },
    {
      header: t('is.active'),
      name: 'isActive',
      type: 'boolean',
      isEditable: true,
      filterEditor: BoolFilter,
      render: ({ value }) => <Switch disabled checked={value} />
    },
    {
      header: t('date.added'),
      name: 'dateAdded',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    },
    {
      header: t('date.modified'),
      name: 'dateModified',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    }
  ];

  return (
    <>
      <Header title={t('payment.receivers')} />
      <Toolbar iamResource={resource} />
      <Table
        iamResource={resource}
        uniqueId={'paymentReceiverId'}
        tableId={'PaymentReceiver'}
        columns={columns}
        urls={urls}
      />
      <NavBar />
    </>
  );
};

export default PaymentReceiver;
